<form>
    <div style="overflow-x: auto; width: 100%;">
        <mat-table [dataSource]="form?.controls" style="min-width: 1400px;">
            <ng-container matColumnDef="acknowledgeFlag">
                <mat-header-cell *matHeaderCellDef style="flex: 0 0 90px; max-width: 90px; padding: 0 8px;">
                    <mat-checkbox (change)="ackAll($event)">ACK</mat-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let element" style="flex: 0 0 90px; max-width: 90px; padding: 0 8px;">
                    <mat-checkbox
                        [checked]="element.controls?.acknowledgeFlag.value === 'Y'"
                        (change)="setFlag($event, element.controls?.acknowledgeFlag)"
                    ></mat-checkbox>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="carInit">
                <mat-header-cell *matHeaderCellDef style="flex: 0 0 120px; max-width: 120px; padding: 0 8px;">Car Init</mat-header-cell>
                <mat-cell *matCellDef="let element" style="flex: 0 0 120px; max-width: 120px; padding: 0 8px;">
                    <ng-container *ngIf="action === 'add'">
                        <mat-form-field
                            class="highlight-dirty bds-mat-dense-form-field w-100"
                            floatLabel="always"
                            appearance="fill"
                        >
                            <mat-label>Car Init <span class="dirty-indicator">*</span> </mat-label>
                            <input matInput [formControl]="element.controls.carInit" />
                        </mat-form-field>
                    </ng-container>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="carNo">
                <mat-header-cell *matHeaderCellDef style="flex: 0 0 120px; max-width: 120px; padding: 0 8px;">Car No</mat-header-cell>
                <mat-cell *matCellDef="let element" style="flex: 0 0 120px; max-width: 120px; padding: 0 8px;">
                    <ng-container *ngIf="action === 'add'">
                        <mat-form-field
                            class="highlight-dirty bds-mat-dense-form-field w-100"
                            floatLabel="always"
                            appearance="fill"
                        >
                            <mat-label>Car No<span class="dirty-indicator">*</span> </mat-label>
                            <input matInput [formControl]="element.controls.carNo" />
                        </mat-form-field>
                    </ng-container>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="carId">
                <mat-header-cell *matHeaderCellDef style="flex: 0 0 130px; max-width: 130px; padding: 0 8px; white-space: nowrap;">Car ID</mat-header-cell>
                <mat-cell *matCellDef="let element" style="flex: 0 0 130px; max-width: 130px; padding: 0 8px; white-space: nowrap;">
                    <ng-container *ngIf="action === 'acknowledge'">
                        {{ element.controls.carInit.value.trim()
                        }}{{ element.controls.carNo.value.trim() }}
                    </ng-container>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="commentType">
                <mat-header-cell *matHeaderCellDef style="flex: 0 0 100px; max-width: 100px; padding: 0 8px; white-space: nowrap;">Comment Type</mat-header-cell>
                <mat-cell *matCellDef="let element" style="flex: 0 0 100px; max-width: 100px; padding: 0 8px;">
                    <ng-container *ngIf="action === 'acknowledge'">
                        {{ element.controls.commentType.value }}
                    </ng-container>
                    <ng-container *ngIf="action === 'add'">
                        <mat-form-field
                            class="highlight-dirty bds-mat-dense-form-field w-100"
                            floatLabel="always"
                            appearance="fill"
                        >
                            <mat-label
                                >Comment Type <span class="dirty-indicator">*</span>
                            </mat-label>
                            <input matInput [formControl]="element.controls.commentType" />
                        </mat-form-field>
                    </ng-container>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="commentCode">
                <mat-header-cell *matHeaderCellDef style="flex: 0 0 110px; max-width: 110px; padding: 0 8px; white-space: nowrap;">Comment Code</mat-header-cell>
                <mat-cell *matCellDef="let element" style="flex: 0 0 110px; max-width: 110px; padding: 0 8px;">
                    <ng-container *ngIf="action === 'acknowledge'">
                        {{ element.controls.commentCode.value }}
                    </ng-container>
                    <ng-container *ngIf="action === 'add'">
                        <mat-form-field
                            class="highlight-dirty bds-mat-dense-form-field w-100"
                            floatLabel="always"
                            appearance="fill"
                        >
                            <mat-label
                                >Comment Code <span class="dirty-indicator">*</span>
                            </mat-label>
                            <input matInput [formControl]="element.controls.commentCode" />
                        </mat-form-field>
                    </ng-container>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="hotListDate">
                <mat-header-cell *matHeaderCellDef style="flex: 0 0 130px; max-width: 130px; padding: 0 8px; white-space: nowrap;">Hot List Date</mat-header-cell>
                <mat-cell *matCellDef="let element" style="flex: 0 0 130px; max-width: 130px; padding: 0 8px; white-space: nowrap;">
                    <ng-container *ngIf="action === 'acknowledge'">
                        {{ element.controls.hotListDate.value | date : 'MM/dd/yyyy HH:mm' : 'UTC' }}
                    </ng-container>
                    <ng-container *ngIf="action === 'add'">
                        <bds-date-time-picker
                            [formControl]="element.controls.hotListDate"
                            label="Hot List Date"
                            type="date"
                            displayFormat="MM/dd/yyyy"
                        ></bds-date-time-picker>
                    </ng-container>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="hotListType">
                <mat-header-cell *matHeaderCellDef style="flex: 0 0 100px; max-width: 100px; padding: 0 8px; white-space: nowrap;">Hot List Type</mat-header-cell>
                <mat-cell *matCellDef="let element" style="flex: 0 0 100px; max-width: 100px; padding: 0 8px;">
                    <ng-container *ngIf="action === 'acknowledge'">
                        {{ element.controls.hotListType.value }}
                    </ng-container>
                    <ng-container *ngIf="action === 'add'">
                        <mat-form-field
                            class="highlight-dirty bds-mat-dense-form-field w-100"
                            floatLabel="always"
                            appearance="fill"
                        >
                            <mat-label
                                >Hot List Type <span class="dirty-indicator">*</span>
                            </mat-label>
                            <input matInput [formControl]="element.controls.hotListType" />
                        </mat-form-field>
                    </ng-container>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="issue">
                <mat-header-cell *matHeaderCellDef style="flex: 1 1 200px; min-width: 200px; padding: 0 8px;">Issue</mat-header-cell>
                <mat-cell *matCellDef="let element" style="flex: 1 1 200px; min-width: 200px; padding: 0 8px; white-space: normal; overflow: visible;">
                    <mat-form-field
                        class="highlight-dirty bds-mat-dense-form-field w-100"
                        floatLabel="always"
                        appearance="fill"
                    >
                        <mat-label>Issue <span class="dirty-indicator">*</span> </mat-label>
                        <textarea
                            matInput
                            bdsShoutcase
                            [formControl]="element.controls.comments"
                            rows="3"
                        ></textarea>
                    </mat-form-field>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="response">
                <mat-header-cell *matHeaderCellDef style="flex: 1 1 200px; min-width: 200px; padding: 0 8px;">User Response</mat-header-cell>
                <mat-cell *matCellDef="let element" style="flex: 1 1 200px; min-width: 200px; padding: 0 8px; white-space: normal; overflow: visible;">
                    <mat-form-field
                        class="w-100"
                        floatLabel="always"
                        appearance="fill"
                    >
                        <mat-label>Response<span class="dirty-indicator">*</span></mat-label>
                        <textarea
                            matInput
                            bdsShoutcase
                            [formControl]="element.controls.userResponse"
                            rows="3"
                        ></textarea>
                    </mat-form-field>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="userId">
                <mat-header-cell *matHeaderCellDef style="flex: 0 0 80px; max-width: 80px; padding: 0 8px; white-space: nowrap;">User ID</mat-header-cell>
                <mat-cell *matCellDef="let element" style="flex: 0 0 80px; max-width: 80px; padding: 0 8px; white-space: nowrap;">
                    {{ element.controls.userId.value }}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="acknowledgeDate">
                <mat-header-cell *matHeaderCellDef style="flex: 0 0 130px; max-width: 130px; padding: 0 8px; white-space: nowrap;">Ack Date</mat-header-cell>
                <mat-cell *matCellDef="let element" style="flex: 0 0 130px; max-width: 130px; padding: 0 8px; white-space: nowrap;">
                    {{ element.controls.acknowledgeDate.value | date : 'MM/dd/yyyy HH:mm' : 'UTC' }}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="acknowledgeUserId">
                <mat-header-cell *matHeaderCellDef style="flex: 0 0 100px; max-width: 100px; padding: 0 8px; white-space: nowrap;">Ack By</mat-header-cell>
                <mat-cell *matCellDef="let element" style="flex: 0 0 100px; max-width: 100px; padding: 0 8px; white-space: nowrap;">
                    {{ element.controls.acknowledgeUserId.value }}
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
    </div>
</form>
<ng-template #responseDialog let-data>
    <h2 mat-dialog-title>Update Responses</h2>
    <mat-dialog-content style="min-height: 200px; min-width: 350px">
        <div>
            <mat-form-field floatLabel="always" appearance="fill" style="display: inherit">
                <mat-label>Response<span class="dirty-indicator">*</span></mat-label>
                <textarea
                    matInput
                    bdsShoutcase
                    rows="3"
                    [(ngModel)]="data['response']"
                    name="response"
                    cols="100"
                ></textarea>
            </mat-form-field>
        </div>
        <div *ngFor="let item of types; let i = index">
            <mat-checkbox
                [checked]="selected === i"
                (change)="selected = i; data['selectedType'] = item?.type ?? 'none'"
                >{{ item?.description }}</mat-checkbox
            >
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button [mat-dialog-close]="data" cdkFocusInitial>Ok</button>
        <button mat-button mat-dialog-close>Cancel</button>
    </mat-dialog-actions>
</ng-template>
